import { refreshIcons } from '../base/utils.js';
import * as Modals from './ui/modal.js';
import * as Toasts from './ui/toast.js';
import * as Offcanvas from './ui/offcanvas.js';
import { initCustomSelect } from './ui/select.js';
import { initDropdowns } from './ui/dropdown.js';
import { initTooltips } from './ui/tooltip.js';
import { initTabs } from './ui/tab.js';
import { initAccordion } from './ui/accordion.js';
import { initCarousel } from './ui/carousel.js';
import { initAlertDismiss } from './ui/alert.js';
import { initTextareaAutoResize, initTextareaManualResize } from './ui/textarea.js';

window.openModal = Modals.openModal;
window.closeUniversalModal = Modals.closeUniversalModal;
window.showModal = Modals.showModal;

window.showToast = Toasts.showToast;

window.openOffcanvas = Offcanvas.openOffcanvas;
window.closeUniversalOffcanvas = Offcanvas.closeUniversalOffcanvas;

export function initComponents() {
    refreshIcons();
    initAlertDismiss();
    initCustomSelect();
    initDropdowns();
    initTabs();
    initAccordion();
    Offcanvas.initOffcanvas();
    initCarousel();
    initTooltips();
    initTextareaAutoResize();
    initTextareaManualResize();
}

window.initComponents = initComponents;

document.addEventListener('DOMContentLoaded', initComponents);
